import React, { Fragment, useEffect} from 'react';
import MetaTags from 'react-meta-tags';

import Loading from '../blocks/loading/Loading';
import Header from '../blocks/header/HearderEn';
import PageTitleServicesInside from '../blocks/page-title/PageTitleServicesInsideEn9'
import Footer from '../blocks/footer/Footer';
import BackToServices from '../components/button/BackToServicesEn';
import Introduction from '../components/services/Introduction';
import WhyComponent from '../components/services/WhyComponent';

const ServicesInsideEn9 = () => {
    document.body.classList.add('single');
    document.body.classList.add('single-adveits_services');
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
    }, []);
    const list = [
        'Sofwave™ is the latest technology to revitalize the skin through innovative stimulation of the production of new collagen. Sofwave™’s Synchronous Ultrasound Parallel Beam Technology is FDA cleared for lifting the eye, submental and neck and reducing fine lines & wrinkles.'
    ]
    const whyList = [
        {
            title: 'Clinically proven technology',
            content: "A multi-center clinical study evaluated the clinical effects of Sofwave™’s technology on facial wrinkles, most patients were marked as improved or significantly improved 12 weeks after a single treatment"
        },
        {
            title: 'Safe and effective',
            content: "Proprietary Synchronous Ultrasound Parallel Beam SUPERB™ technology with integrated cooling Sofcool™, while ensuring no damage to the epidermis or to the underlying structures beneath the dermis"
        },
        {
            title: 'Non-invasive',
            content: "Ultrasound energy precisely passes through the skin’s surface, heating the mid-dermal tissue at just the right depth and temperature to rejuvenate collagen fibers. Patients can get right back to normal life quickly following treatment"
        },
        {
            title: 'Treats all skin types',
            content: "Darker skin types are more susceptible to burns with the different light-based therapies. With Ultrasound, the treatment is safe and effective regardless of the patient’s skin type"
        },
        {
            title: 'High patient satisfaction',
            content: "In a multi-center clinical study, 72% of the patients were satisfied with their results and rated them as improved to very much improved"
        }
    ]
    const titleStyle = {
        flexShrink: "0",
        fontWeight: '600',
        color: '#333',
        fontSize:'1.5rem'
    };
    const contentStyle = { 
        maxWidth: '80%',
        width: '100%', 
        textAlign: 'left',
        fontSize:'1.5rem'
    }
    return (
        <Fragment>
            <MetaTags>
                <meta charSet="UTF-8" />
                <title>Service inside | Mykery - Beauty Salon React JS Template</title>

                <meta httpEquiv="x-ua-compatible" content="ie=edge" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="description" content="" />
                <meta name="keywords" content="" />
                <meta name="robots" content="index, follow, noodp" />
                <meta name="googlebot" content="index, follow" />
                <meta name="google" content="notranslate" />
                <meta name="format-detection" content="telephone=no" />
            </MetaTags>

            <Loading />

            <Header logoColor="dark"  position='relative'  />

            <main id="main" className="site-main" style={{paddingTop:"7.368rem",paddingBottom:"7.368rem"}}>
                <PageTitleServicesInside />


                <div id="page-content" className="spacer p-top-xl">
                    <div className="wrapper">
                        <div className="content">
                            <div id="single">
                                <div id="single-content">
                                    <div id="img" className="block">
                                        <div className="img-no-wrap-1">
                                            <div className="img object-fit">
                                                <div className="object-fit-cover" style={{ display: "flex", justifyContent: "space-around", columnGap: "1rem" }}>
                                                <div style={{ maxHeight: '700px', flex: '1' }}><img src="assets/img/placeholder/SOFWARE机器.jpg" style={{objectFit:"contain"}} alt="Hair Treatments" /></div>
                                                    <div style={{ maxHeight: '700px', flex: '2' }}><img src="assets/img/placeholder/sofwave证书.png" style={{objectFit:"contain"}} alt="Hair Treatments" /></div>
                                                    <div style={{ maxHeight: '700px', flex: '1' }}><img src="assets/img/placeholder/SOFWARE证书.jpg" style={{objectFit:"contain"}} alt="Hair Treatments" /></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div id="description" className="block spacer p-top-xl">
                                        <div className="description">
                                            <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting.</p>
                                            <p>Contrary to popular belief, Lorem Ipsum is not simply random text. It has roots in a piece of classical Latin literature from 45 BC, making it over 2000 years old. Richard McClintock, a Latin professor at Hampden-Sydney College in Virginia.</p>
                                        </div>
                                    </div> */}

                                    <Introduction lang='en'  list={['']} tips={'Sofwave™ is the latest technology to revitalize the skin through innovative stimulation of the production of new collagen. Sofwave™’s Synchronous Ultrasound Parallel Beam Technology is FDA cleared for lifting the eye, submental and neck and reducing fine lines & wrinkles.'}></Introduction>
                                    <WhyComponent list={whyList} title='Why Sofwave™' />
                                    <div className="block spacer p-top-xl">
                                        <div className="title">
                                            <h2 className="hr">How does Sofwave™ work?</h2>
                                        </div>
                                        <div>
                                            <div style={{ paddingBottom: '1.579rem', color:"#262626", lineHeight: "2rem",fontSize:"1.5rem" }}>The depth for treating wrinkles is 1.5mm in the mid-dermis. Our unique, Synchronous
                                                Ultrasound Parallel Beam SUPERB™ technology generates heat at this exact depth in the
                                                mid-dermis. Additionally, there is an integrated cooling mechanism Sofcool ™ that protects
                                                the uppermost skin layer from burning.</div>
                                            <div style={{ paddingBottom: '1.579rem', color:"#262626", lineHeight: "2rem" ,fontSize:"1.5rem"}}>The impacted treatment zones stimulate a healing response, called neo-collagenases, which
                                                increases and regenerates the collagen in the skin, leading to the reduction in fine lines and
                                                wrinkles, and lifting the eyebrow, submental and neck.</div>
                                        </div>
                                    </div>

                                    <div id="price-list" className="block spacer p-top-xl">
                                        <div className="title">
                                            <h2 className="hr">Service Details</h2>
                                        </div>

                                        <div className="price-list">
                                            <div className="price-list-items">
                                                <div className="price-list-item">
                                                    {/* <div className="price-list-item-title">
                                                        <h3>Special in-salon treatments</h3>
                                                    </div> */}

                                                    <ul className="price-list-item-list-group list-group">

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        <span className="list-group-title" style={titleStyle}>Face Contour Lifting and Double Chin</span>
                                                        {/* <span className="list-group-price" style={contentStyle}>120 mins</span> */}  
                                                    </li>

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        <span className="list-group-title" style={titleStyle}>Eyes and Forehead Wrinkles</span>
                                                        {/* <span className="list-group-price" style={contentStyle}>120 mins</span> */}
                                                    </li>

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        <span className="list-group-title" style={titleStyle}>Neck and Double Chin</span>
                                                        {/* <span className="list-group-price" style={contentStyle}>120 mins</span> */}
                                                    </li>

                                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                                        <span className="list-group-title" style={titleStyle}>Full Face Lifting</span>
                                                        {/* <span className="list-group-price" style={contentStyle}>120 mins</span> */}
                                                    </li>

                                                    </ul>
                                                </div>

                                                <div className="price-list-item">
                                                    {/* <div className="price-list-item-title">
                                                        <h3>Haircut and hair styling</h3>
                                                    </div> */}

                                                    <ul className="price-list-item-list-group list-group">
                                                        {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>玻尿酸瀑布护理</span>
                                                            <span className="list-group-price" style={contentStyle}>90-120 mins</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>氧气泡泡护理</span>
                                                            <span className="list-group-price" style={contentStyle}>90 mins</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Hair styling</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li> */}

                                                        {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Hair styling for occasion</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Consulting</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Trial hairstyling for occasion</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li> */}
                                                    </ul>
                                                </div>

                                                <div className="price-list-item">
                                                    {/* <div className="price-list-item-title">
                                                        <h3>Hair coloring</h3>
                                                    </div> */}

                                                    <ul className="price-list-item-list-group list-group">
                                                        {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>All hair color</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Root color</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Highlights</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li>

                                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                                            <span className="list-group-title" style={titleStyle}>Hair toning</span>
                                                            <span className="list-group-price" style={contentStyle}>From 35 $</span>
                                                        </li> */}
                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <BackToServices />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    );
};

export default ServicesInsideEn9;